import EventAboutForm from './event-about-form'

export default EventAboutForm;